import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-Sweden",
  "use": "icon-Sweden-usage",
  "viewBox": "0 0 1536 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1536 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-Sweden\"><path d=\"M0 0h1536v1024H0z\" fill=\"#005398\" p-id=\"42477\" /><path d=\"M672 0v416h864v192H672v416h-192V608H0v-192h480V0h192z\" fill=\"#FFC900\" p-id=\"42478\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol